import { render, staticRenderFns } from "./UnterrichtDashboardWidget.vue?vue&type=template&id=5d71c4c9&scoped=true"
import script from "./UnterrichtDashboardWidget.vue?vue&type=script&lang=ts"
export * from "./UnterrichtDashboardWidget.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtDashboardWidget.vue?vue&type=style&index=0&id=5d71c4c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71c4c9",
  null
  
)

export default component.exports